import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {DataTableLocalization, Translate} from "../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../config/index";
import {connect} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../config/design/TableIcons";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import moment from "jalali-moment";
import {TableCount, TablePage} from "../../../config/Permissions";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import AppCardLoaderTable from "../../components/Skeletons/AppCardLoaderTable";
import Button from "@material-ui/core/Button/Button";
import VisibilityRoundedIcon from '@material-ui/icons/VisibilityRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import AddTicketModal from "./add_ticket/AddTicketModal";

class Tickets extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        columns: [
            { title: Translate.code,
                field: 'unique_code',
                filterPlaceholder: Translate.search
            },
            { title: Translate.subject,
                field: 'subject',
                filterPlaceholder: Translate.search
            },
            { title: Translate.requestType,
                field: 'target',
                render: rowData =>(
                    <>
                        <Typography>
                            {Translate.department +" "+rowData.target.name}
                        </Typography>

                    </>
                )
            },
            { title: Translate.priority,
                field: 'priority',
                filterPlaceholder: Translate.search
            },
            { title: Translate.ticket_status,
                editable: 'never',
                field: 'status',
                filterPlaceholder: Translate.choose,
                lookup: {
                    "sent" :
                        <Typography style={{color: "#58b956"}} variant="body2"> {Translate.sentTicket}</Typography>
                    ,"read" :
                        <Typography style={{color: "#51a5b9"}} variant="body2"> {Translate.read}</Typography>
                    , "unread":
                        <Typography style={{color: "#b9554e"}} variant="body2"> {Translate.unread}</Typography>
                    , "closed":
                        <Typography style={{color: "#929292"}} variant="body2"> {Translate.closed}</Typography>
                },
            },
            { title: Translate.ticket_edited_at,editable: 'never',filtering: false, field: 'lastUpdate'},
            {
                title: Translate.action,
                editable: 'never',
                field: 'action',
                render: rowData =>(
                    <>
                        <Button
                            variant="outlined"
                            size="small"
                            style={{marginBottom:5}}
                            startIcon={
                                <ChevronLeftRoundedIcon/>
                            }
                            onClick={() => this.props.history.push(`/ticket/${rowData.id}`)}
                        >
                            {Translate.view}
                        </Button>
                    </>
                )
            }
        ],

        data: [],
        loading:false,
        ChangeLoader:false,
        manage:this.props.manage,
    };
    componentDidMount(){
        this.loadData();
    }
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()

    }
    render(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        let {user} = this.props;
        return (
            <>
                {
                this.state.loading ? <AppCardLoaderTable/> :
                    <Container maxWidth="xl">
                        <MaterialTable
                            tableRef={this.tableRef}
                            icons={tableIcons}
                            title={<AddTicketModal reload={() => this.loadData()}/>}
                            localization={DataTableLocalization}
                            columns={this.state.columns}
                            data={query =>
                                new Promise((resolve, reject) => {
                                    axios.get(`${defaultVariabls.url}/${this.props.manage ? "tickets" : "my-tickets"}/quickView?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`, config)
                                        .then(response => {
                                            let data = [];
                                            // eslint-disable-next-line
                                            response.data.data.map((row) => {
                                                data.push({
                                                    id: row.id,
                                                    unique_code: row.unique_code,
                                                    subject: !!row.subject ? row.subject.length> 25 ? row.subject.slice(0,25)+"..." : row.subject : '',
                                                    receiver: row.receiver.first_name + " " + row.receiver.last_name,
                                                    starter: row.starter.first_name + " " + row.starter.last_name,
                                                    type: row.type,
                                                    target: row.type === "system" ? row.department : row.order_item,
                                                    priority: Translate[row.priority],
                                                    contact: user.id === row.starter.id ? row.receiver.first_name + " " + row.receiver.last_name : row.starter.first_name + " " + row.starter.last_name,
                                                    status: row.is_closed ? "closed" : row.status,
                                                    lastUpdate:
                                                        <Typography>
                                                            {`${moment(row.updated_at).locale('fa').fromNow()}`}
                                                            <br/>
                                                            {`${moment(row.updated_at).locale('fa').format( 'HH:mm , YYYY/M/D')}`}
                                                        </Typography>
                                                })
                                            });
                                            resolve({
                                                data: data,
                                                page: response.data.current_page - 1,
                                                totalCount: response.data.total,
                                            })
                                        }).catch(error => {
                                        console.log(error.response)
                                    })
                                })
                            }
                            options={{
                                pageSize: TablePage,
                                pageSizeOptions: TableCount,
                            }}

                        />
                    </Container>
                }
            </>
        );
    }
}

const mstp = state => ({
    locale: state.locale,
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Tickets))));